import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { DEFAULT_BORDER_RADIUS } from 'src/theme/constants';
import { ScrollArea } from '../../ScrollArea/ScrollArea';

export const Panels = styled('div', { name: 'PanelCard' })(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(20),
}));

export const PanelCard = styled('div', { name: 'PanelCard' })(({ theme }) => ({
  borderRadius: DEFAULT_BORDER_RADIUS,
  borderTopLeftRadius: DEFAULT_BORDER_RADIUS,
  border: `1px solid ${theme.palette.border}`,
  overflow: 'hidden',
  height: `100%`,
  backgroundColor: theme.palette.white,
}));

export const PanelCardTitle = styled('div', { name: 'PanelCard' })(({ theme }) => ({
  paddingLeft: theme.spacing(4),
}));

const PanelCardContentBox = styled('div', { name: 'PanelCard' })(({ theme }) => ({
  paddingTop: theme.spacing(24),
  paddingBottom: theme.spacing(24),
  [`&:has(${PanelCardTitle})`]: {
    paddingTop: theme.spacing(16),
  },
}));

export const PanelCardContent = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box sx={{ pl: 36, pr: 20 }}>
      <ScrollArea className="os-host-flexbox">
        <PanelCardContentBox>{children}</PanelCardContentBox>
      </ScrollArea>
    </Box>
  );
};
